import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "icon-popup" }
const _hoisted_6 = { class: "icon-first" }
const _hoisted_7 = { class: "icon-last icon-last" }
const _hoisted_8 = { class: "form-inline" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = ["value"]

import { defineAsyncComponent } from 'vue';
import { icon_bar_status, select_icon, } from "@/composables/flagIcon"
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

export default /*@__PURE__*/_defineComponent({
  __name: 'indexIcoicon',
  setup(__props) {

const abstractIcon = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/abstractIcon.vue"))
const animalIcon = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/animalIcon.vue"))
const brandIcons = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/brandIcons.vue"))
const Business = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/businessIcons.vue"))
const Chart = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/chartIcons.vue"))
const Construction = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/constructionIcons.vue"))
const Currency = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/currencyIcons.vue"))
const Device = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/deviceIcons.vue"))
const Directional = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/directionalIcons.vue"))
const Education = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/educationIcons.vue"))
const Filetype = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/filetypeIcons.vue"))
const Emoticon = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/emoticonIcons.vue"))
const Food = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/foodIcons.vue"))
const Kids = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/kidsIcons.vue"))
const Law = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/lawIcons.vue"))
const Mathematical = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/mathematicalIcons.vue"))
const Medical = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/medicalIcons.vue"))
const Mobile = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/mobileIcons.vue"))
const Multimedia = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/multimediaIcons.vue"))
const Payment = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/paymentIcons.vue"))
const Person = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/personIcons.vue"))
const Search = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/searchIcons.vue"))
const Social = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/socialIcons.vue"))
const Sport = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/sportIcons.vue"))
const Text = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/textIcons.vue"))
const Transport = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/transportIcons.vue"))
const Travel = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/travelIcons.vue"))
const Weather = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/weatherIcons.vue"))
const Web = defineAsyncComponent(() => import("@/components/theme/icons/ico_icon/webIcons.vue"))

function icon_bar(icon: string) {
    select_icon.value.class = 'icofont icofont-' + icon;
    select_icon.value.tag = '<i class="icofont icofont-' + icon + '"></i>';
    icon_bar_status.value = true;
}
function close_icon_bar() {
    icon_bar_status.value = false;
}
function copy_icon() {
    toast.info('Code Copied to clipboard! ', {
        hideProgressBar: true, autoClose: 2000, theme: 'colored', position: 'bottom-right',
    });
    navigator.clipboard.writeText(select_icon.value.tag);
    document.execCommand('copy');
}

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Icons",
      title: "ICO Icon"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(abstractIcon), { onSelected: icon_bar }),
        _createVNode(_unref(animalIcon), { onSelected: icon_bar }),
        _createVNode(_unref(brandIcons), { onSelected: icon_bar }),
        _createVNode(_unref(Business), { onSelected: icon_bar }),
        _createVNode(_unref(Chart), { onSelected: icon_bar }),
        _createVNode(_unref(Construction), { onSelected: icon_bar }),
        _createVNode(_unref(Currency), { onSelected: icon_bar }),
        _createVNode(_unref(Device), { onSelected: icon_bar }),
        _createVNode(_unref(Directional), { onSelected: icon_bar }),
        _createVNode(_unref(Education), { onSelected: icon_bar }),
        _createVNode(_unref(Emoticon), { onSelected: icon_bar }),
        _createVNode(_unref(Filetype), { onSelected: icon_bar }),
        _createVNode(_unref(Food), { onSelected: icon_bar }),
        _createVNode(_unref(Kids), { onSelected: icon_bar }),
        _createVNode(_unref(Law), { onSelected: icon_bar }),
        _createVNode(_unref(Mathematical), { onSelected: icon_bar }),
        _createVNode(_unref(Medical), { onSelected: icon_bar }),
        _createVNode(_unref(Mobile), { onSelected: icon_bar }),
        _createVNode(_unref(Multimedia), { onSelected: icon_bar }),
        _createVNode(_unref(Payment), { onSelected: icon_bar }),
        _createVNode(_unref(Person), { onSelected: icon_bar }),
        _createVNode(_unref(Search), { onSelected: icon_bar }),
        _createVNode(_unref(Social), { onSelected: icon_bar }),
        _createVNode(_unref(Sport), { onSelected: icon_bar }),
        _createVNode(_unref(Text), { onSelected: icon_bar }),
        _createVNode(_unref(Transport), { onSelected: icon_bar }),
        _createVNode(_unref(Travel), { onSelected: icon_bar }),
        _createVNode(_unref(Weather), { onSelected: icon_bar }),
        _createVNode(_unref(Web), { onSelected: icon_bar })
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["icon-hover-bottom p-fixed fa-fa-icon-show-div", { 'opecity-0': !_unref(icon_bar_status) }]),
      style: _normalizeStyle([_unref(icon_bar_status) ? { 'display': 'block' } : { 'display': 'none' }])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "close-icon",
              onClick: close_icon_bar
            }, _cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "icofont icofont-close" }, null, -1)
            ])),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("i", {
                class: _normalizeClass(["fa-2x", [_unref(select_icon).class]])
              }, null, 2)
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "icon-class" }, [
              _createElementVNode("label", { class: "icon-title" }, "Class"),
              _createElementVNode("span", null, "icon-drupal")
            ], -1)),
            _createElementVNode("div", _hoisted_7, [
              _cache[1] || (_cache[1] = _createElementVNode("label", { class: "icon-title" }, "Markup", -1)),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("input", {
                    class: "inp-val form-control m-r-10",
                    type: "text",
                    ref: "text",
                    value: _unref(select_icon).tag
                  }, null, 8, _hoisted_10),
                  _createElementVNode("button", {
                    class: "btn btn-primary notification",
                    onClick: copy_icon
                  }, "Copy text")
                ])
              ])
            ])
          ])
        ])
      ])
    ], 6)
  ], 64))
}
}

})